/** Commit a numeric TextField draft; empty/invalid reverts to fallback. */
export function commitNumericDraft(raw, { min, max, fallback, parse = parseFloat } = {}) {
  const trimmed = String(raw ?? '').trim();
  const n = parse(trimmed);
  if (trimmed === '' || !Number.isFinite(n)) return fallback;
  let out = n;
  if (min !== undefined && Number.isFinite(min)) out = Math.max(min, out);
  if (max !== undefined && Number.isFinite(max)) out = Math.min(max, out);
  return out;
}

export const parseIntField = (raw) => parseInt(raw, 10);
